/**
 * @param dateObject - moment.js object
 * @returns {{hoursAngle, minutesAngle, secondsAngle}}
 */
export default function getAngles(dateObject) {
    const HOURS_ANGLE = 30;
    const MINUTES_ANGLE = 6;
    const SECONDS_ANGLE = 6;

    return {
        hoursAngle: getHourAngleVal({
            angle: HOURS_ANGLE,
            value: dateObject.hour()
        },
        {
            angle: MINUTES_ANGLE,
            value: dateObject.minute()
        },
        MINUTES_ANGLE),
        minutesAngle: getAngleVal(MINUTES_ANGLE, dateObject.minute()),
        secondsAngle: getAngleVal(SECONDS_ANGLE, dateObject.second()),
    }
}

function getAngleVal(angle, value) {
    if ( value === 0 ) {
        return 0
    } else {
        return value * angle;
    }
}

function getHourAngleVal(hours, minutes, ANGLE_VAL) {
    let addedVal = 0;
    if( hours.value === 0 ) {
        return 0
    } else {
        let hoursAngles = getAngleVal(hours.angle, hours.value);
        const minutesAngles = getAngleVal(minutes.angle, minutes.value);

        addedVal = Math.floor(minutesAngles / 72) * ANGLE_VAL;

        return hoursAngles + addedVal
    }
}


// WEBPACK FOOTER //
// ./src/_app/react-components/ClockComponent/helpers/getAngles.js